// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1EHDy","header":"header___3nkDv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/ItemCardCarousel.scss
// module id = orCU
// module chunks = 57